import axiosInstance from './axios.config';

// Re-export the configured axios instance as 'api' for consistency
export const api = axiosInstance;
export default api;

// Re-export isAxiosError and getErrorMessage for usage in other modules
export { getErrorMessage, isAxiosError } from './axios.config';
